import { render, staticRenderFns } from "./DownloadList.vue?vue&type=template&id=591d3960&scoped=true"
import script from "./DownloadList.vue?vue&type=script&lang=js"
export * from "./DownloadList.vue?vue&type=script&lang=js"
import style0 from "./DownloadList.vue?vue&type=style&index=0&id=591d3960&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d3960",
  null
  
)

export default component.exports